import React from 'react';
import T from 'prop-types';
import update from 'immutability-helper';

/**
 * This HOC is a duplica of vdkweb-navigation withLayout to change the default behavior
 * when moving down from the second last row. If there is nothing in below
 * the current element, the focus will be moved to the last element
 * in the last row
 */

const lineParser = line => {
  const strArr = line.split(' ');
  const output = [];

  for (let i = 0, l = strArr.length; i < l; i += 1) {
    const str = strArr[i];

    if (str !== '' && str[0] !== '.') {
      output.push(str);
    } else if (str[0] === '.') {
      output.push(null);
    }
  }

  return output;
};

const layoutParser = layout => {
  const lineArr = layout.split('\n');
  const output = [];

  for (let i = 0, l = lineArr.length; i < l; i += 1) {
    const line = lineArr[i];

    output.push(lineParser(line));
  }

  return output;
};

const findNextLeft = (layout, topLeft, bottomLeft) => {
  if (topLeft[1] === 0) {
    return '';
  }

  for (let i = topLeft[1] - 1; i >= 0; i -= 1) {
    for (let ii = topLeft[0]; ii <= bottomLeft[0]; ii += 1) {
      if (layout[ii][i]) {
        return layout[ii][i];
      }
    }
  }

  return '';
};

const findNextRight = (layout, topRight, bottomRight) => {
  if (topRight[1] === layout[0].length - 1) {
    return '';
  }

  for (let i = topRight[1] + 1; i <= layout[0].length - 1; i += 1) {
    for (let ii = topRight[0]; ii <= bottomRight[0]; ii += 1) {
      if (layout[ii][i]) {
        return layout[ii][i];
      }
    }
  }

  return '';
};

const findNextUp = (layout, topLeft, topRight) => {
  if (topLeft[0] === 0) {
    return '';
  }

  for (let i = topLeft[0] - 1; i >= 0; i -= 1) {
    for (let ii = topLeft[1]; ii <= topRight[1]; ii += 1) {
      if (layout[i][ii]) {
        return layout[i][ii];
      }
    }
  }

  return '';
};

const findNextDown = (layout, bottomLeft, bottomRight) => {
  if (bottomLeft[0] === layout.length - 1) {
    return '';
  }

  for (let i = bottomLeft[0] + 1; i <= layout.length - 1; i += 1) {
    for (let ii = bottomLeft[1]; ii <= bottomRight[1]; ii += 1) {
      if (layout[i][ii]) {
        return layout[i][ii];
      }
    }
  }

  const lastRow = layout[layout.length - 1];
  const last = lastRow[lastRow.length - 1];

  return last;
};

const withLayout = Component => {
  class XXX extends React.Component {
    componentWillMount() {
      this.updateLayout(this.props);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.layout === nextProps.layout) {
        return;
      }

      this.updateLayout(nextProps);
    }

    updateLayout(props) {
      const layoutString = props.layout;

      this.layout = layoutParser(layoutString);
    }

    updateNav(nav = {}) {
      let topLeft;
      let topRight;
      let bottomLeft;
      let bottomRight;

      const parent = this.props.nav.id;

      for (let i = 0, l = this.layout.length; i < l; i += 1) {
        const line = this.layout[i];

        for (let ii = 0, ll = line.length; ii < ll; ii += 1) {
          const item = line[ii];

          if (item === nav.id) {
            if (!topLeft) {
              topLeft = [i, ii];
            }

            if (topLeft && (!topRight || topRight[1] < ii)) {
              topRight = [i, ii];
            }

            if (topLeft && topRight && (!bottomLeft || bottomLeft[0] < i)) {
              bottomLeft = [i, ii];
            }

            if (
              topLeft &&
              topRight &&
              bottomLeft &&
              (!bottomRight || bottomRight[0] < i || bottomRight[1] < ii)
            ) {
              bottomRight = [i, ii];
            }
          }

          if (topLeft && !topRight && ii === ll - 1) {
            topRight = topLeft;
          }

          if (topLeft && topRight && !bottomLeft && i === l - 1) {
            bottomLeft = topLeft;
            bottomRight = topRight;
          }
        }
      }

      if (topLeft) {
        const nextleft = findNextLeft(this.layout, topLeft, bottomLeft);
        const nextright = findNextRight(this.layout, topRight, bottomRight);
        const nextup = findNextUp(this.layout, topLeft, topRight);
        const nextdown = findNextDown(this.layout, bottomLeft, bottomRight);

        const output = {
          parent,
          nextleft,
          nextright,
          nextup,
          nextdown,
        };

        return output;
      }

      return {};
    }

    renderChildren() {
      const { children } = this.props;

      return React.Children.map(children, child => {
        if (!child.props.nav) {
          return child;
        }

        const newNav = this.updateNav(child.props.nav);
        const mergedNav = update(child.props.nav, { $merge: newNav });

        return React.cloneElement(child, {
          nav: mergedNav,
        });
      });
    }

    render() {
      const newNav = {
        ...this.props.nav,
        useLastFocus: true,
      };

      const newProps = {
        ...this.props,
        nav: newNav,
      };

      return <Component {...newProps}>{this.renderChildren()}</Component>;
    }
  }

  XXX.propTypes = {
    layout: T.string,
    nav: T.object,
    children: T.node,
  };

  return XXX;
};

export default withLayout;
